// @tennis-matches/services/governance
// E-Mail-Verfügbarkeit für Selbstregistrierung über rate-limited API (kein direkter anon-RPC).

import { resolveApiUrl } from "../api/get-api-base-url.js";

function __asStr(v) {
  return String(v ?? "").trim();
}

function __normalizeSignupEmail(email) {
  return __asStr(email).toLowerCase();
}

function __isSignupEmailBackendUnavailable(res, body) {
  if (res.status === 502 || res.status === 530) return true;
  if (res.status !== 503) return false;
  const reason = __asStr(body?.reason);
  return (
    reason === "missing-backend-url" ||
    reason === "backend-unreachable" ||
    !reason
  );
}

/**
 * @param {string} rawEmail
 * @param {{ bypassCache?: boolean }} [options] – bypassCache wird ignoriert (Legacy-Parameter).
 */
export async function checkSignupEmailAvailableRemote(rawEmail, _options = {}) {
  const email = __normalizeSignupEmail(rawEmail);
  if (!email || !email.includes("@")) {
    return { ok: true, available: true, skipped: true, reason: "invalid-format" };
  }

  try {
    const res = await fetch(resolveApiUrl("/api/public/auth/check-signup-email"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      cache: "no-store",
      body: JSON.stringify({ email }),
    });

    let body = {};
    try {
      body = await res.json();
    } catch {
      body = {};
    }

    if (res.status === 429) {
      const retryAfterSec = Number(body?.retry_after_sec) > 0 ? Number(body.retry_after_sec) : 20;
      return {
        ok: true,
        available: null,
        rateLimited: true,
        retryAfterSec,
        blacklisted: body?.blacklisted === true,
        reason: __asStr(body?.reason) || "rate_limited",
        errorMessageKey: "auth.register.emailCheck.rateLimited",
      };
    }

    if (!res.ok || body?.ok === false) {
      const backendUnavailable = __isSignupEmailBackendUnavailable(res, body);
      return {
        ok: false,
        reason: backendUnavailable ? "backend-unavailable" : "api-failed",
        backendUnavailable,
        errorMessageKey: backendUnavailable
          ? "auth.register.emailCheck.errorBackendUnavailable"
          : "auth.register.emailCheck.errorTechnical",
      };
    }

    return {
      ok: true,
      available: body.available === true,
      skipped: body.skipped === true,
    };
  } catch (error) {
    return {
      ok: false,
      reason: "network",
      error,
      errorMessageKey: "auth.register.emailCheck.errorTechnical",
    };
  }
}
